import { BooleanFormType } from "Store/interfaces/FormTypes";
import { isDefined } from "Utils/functions";
import { AdviceProductDetailsBackendValues } from "../../../Advice/ProductDetails/FormElements/interfaces";
import { AkaChildProductIntroFormValues } from "./akaChildProductIntroInterfaces";

export const mapAkaChildAdviceToForm = (
  adviceProductValues: AdviceProductDetailsBackendValues | undefined,
): Partial<AkaChildProductIntroFormValues> => ({
  pep: isDefined(adviceProductValues) ? BooleanFormType.FALSE : undefined,
});
